import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  FaChevronLeft,
  FaChevronRight,
  FaCommentDots,
  FaExclamationCircle,
} from "react-icons/fa";
import Header from "../header/header";
import Footer from "../footer/footer";
import "./MySessions.css";

const CARDS_PER_PAGE = 5;

const MySessionsPage = () => {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("ALL ACTIVITY");
  const [selectedAstro, setSelectedAstro] = useState(null);
  const [chatPage, setChatPage] = useState(0);
  const [listPage, setListPage] = useState(1);
  const [searchDate, setSearchDate] = useState("");

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const customerId = localStorage.getItem("customerId") || "1238";
        const response = await axios.get(
          `https://heastro.in/heastro-service/astrochat/chat-logs/customer/${customerId}`
        );
        setSessions(response.data);
      } catch (error) {
        console.error("Error fetching sessions:", error);
      } finally { 
        setLoading(false);
      }
    };
    fetchSessions();
  }, []);

  const filteredData = sessions.filter((item) => {
    if (filter === "ALL ACTIVITY" || filter === "CHAT") return true;
    if (filter === "CALL") return false;
    return true;
  });

  const totalPages = Math.ceil(filteredData.length / CARDS_PER_PAGE);
  const paginatedData = filteredData.slice(
    (listPage - 1) * CARDS_PER_PAGE,
    listPage * CARDS_PER_PAGE
  );

  const openDetail = (astro) => {
    setSelectedAstro(astro);
    setChatPage(0);
  };

  // ── DETAIL VIEW ──────────────────────────────────────────────
  if (selectedAstro) {
   const allSessions = selectedAstro.sessions || [];

// Pehle filteredSessions define karo
const filteredSessions = searchDate
  ? allSessions.filter((s) => {
      const sessionDate = new Date(s.chatStartTime).toISOString().split("T")[0];
      return sessionDate === searchDate;
    })
  : allSessions;

// Ab use karo
const currentSession = filteredSessions[chatPage] ?? filteredSessions[0];
const totalChats = filteredSessions.length;

    return (
      <div className="sess-page-container">
        <Header />
        <div className="sess-detail-view sess-animate-up">

          <div className="sess-detail-topbar">
            <button className="sess-back-btn" onClick={() => setSelectedAstro(null)}>
              <FaChevronLeft /> Back
            </button>
            <div className="sess-astro-top-info">
              <img src={selectedAstro.photoUrlpath} alt={selectedAstro.astrologerName} />
              <div>
                <h3 className="sess-astro-name">{selectedAstro.astrologerName}</h3>
                <p className="sess-astro-sub">Consultation History</p>
              </div>
            </div>
            <div className="sess-chat-counter">
              {chatPage + 1} / {totalChats}
            </div>
          </div>

{/* Date Search Bar */}
<div className="sess-date-search">
  <div className="sess-search-inner">
    <span className="sess-search-icon">📅</span>
    <input
      type="date"
      className="sess-date-input"
      value={searchDate}
      onChange={(e) => {
        setSearchDate(e.target.value);
        setChatPage(0);
      }}
      placeholder="Filter by date"
    />
    {searchDate && (
      <button
        className="sess-clear-date"
        onClick={() => { setSearchDate(""); setChatPage(0); }}
      >
        ✕ Clear
      </button>
    )}
  </div>
  {searchDate && (
    <p className="sess-search-result-txt">
      {filteredSessions.length > 0
        ? `${filteredSessions.length} session(s) found for ${new Date(searchDate + "T00:00:00").toDateString()}`
        : `No sessions found for this date`}
    </p>
  )}
</div>

          {/* Pagination nav */}
          <div className="sess-pagination-nav">
            <button
              className="sess-pag-btn"
              disabled={chatPage === 0}
              onClick={() => setChatPage((p) => p - 1)}
            >
              <FaChevronLeft /> Prev
            </button>
            <div className="sess-pag-dots">
              {allSessions.map((_, i) => (
                <span
                  key={i}
                  className={`sess-dot-page ${i === chatPage ? "active" : ""}`}
                  onClick={() => setChatPage(i)}
                />
              ))}
            </div>
            <button
              className="sess-pag-btn"
              disabled={chatPage === totalChats - 1}
              onClick={() => setChatPage((p) => p + 1)}
            >
              Next <FaChevronRight />
            </button>
          </div>

{filteredSessions.length === 0 && searchDate && (
  <div className="sess-no-date-result">
    <span>🔍</span>
    <p>No chats found for <strong>{new Date(searchDate + "T00:00:00").toDateString()}</strong></p>
    <button className="sess-clear-date" onClick={() => { setSearchDate(""); setChatPage(0); }}>
      Show All Sessions
    </button>
  </div>
)}

          {/* Chat window */}
          {currentSession && (
            <div className="sess-fullscreen-chat">
              <div className="sess-fullchat-header">
                <div className="sess-fch-item">
                  <span className="sess-fch-label">📅 DATE &amp; TIME</span>
                  <span className="sess-fch-val">{currentSession.chatStartTime}</span>
                </div>
                <div className="sess-fch-divider" />
                <div className="sess-fch-item">
                  <span className="sess-fch-label">⏳ DURATION</span>
                  <span className="sess-fch-val">{currentSession.duration}</span>
                </div>
                <div className="sess-fch-divider" />
                <div className="sess-fch-item">
                  <span className="sess-fch-label">💬 MESSAGES</span>
                  <span className="sess-fch-val">{currentSession.chatMessages?.length || 0}</span>
                </div>
              </div>

              <div className="sess-fullchat-messages">
                {currentSession.chatMessages?.length > 0 ? (
                  currentSession.chatMessages.map((msg, mIdx) => (
                    <div
                      key={mIdx}
                      className={`sess-msg-row ${msg.senderCatg === "CUSTOMER" ? "sess-sent" : "sess-received"}`}
                    >
                      <div className="sess-msg-bubble">
                        {msg.messageText}
                        {msg.fileUrl && (
                          <img src={msg.fileUrl} alt="attachment" className="sess-msg-img" />
                        )}
                        <span className="sess-msg-time">
                          {new Date(msg.receiveTime).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="sess-no-messages">No messages in this session.</div>
                )}
              </div>
            </div>
          )}
        </div>
        <Footer />
      </div>
    );
  }

  // ── MAIN LIST VIEW ───────────────────────────────────────────
  return (
    <div className="sess-page-container">
      <Header />
      <div className="sess-wrapper">

        <div className="sess-hero-section">
          <h1 className="sess-cinzel-font">
            <span className="sess-maroon">MY SESSIONS</span>
          </h1>
          <p className="sess-desc">Review your past consultations and active requests.</p>
        </div>

        {/* Stats panel — mobile only (top) */}
        <div className="sess-stats-mobile">
          <div className="sess-stats-inner">
            <div className="sess-stat-unit">
              <h3>{sessions.length}</h3>
              <p>TOTAL CHATS</p>
            </div>
            <div className="sess-stat-divider" />
            <div className="sess-stat-unit">
              <h3>0</h3>
              <p>VOICE CALLS</p>
            </div>
            <div className="sess-stat-divider" />
            <div className="sess-stat-unit sess-support-mobile">
              <span className="sess-dot-green" />
              <p>24/7 Support</p>
            </div>
          </div>
        </div>

        <div className="sess-layout-grid">

          <aside className="sess-sidebar">
            {["ALL ACTIVITY", "CHAT", "CALL"].map((t) => (
              <button
                key={t}
                className={`sess-mini-tab ${filter === t ? "sess-active" : ""}`}
                onClick={() => { setFilter(t); setListPage(1); }}
              >
                {t}
              </button>
            ))}
          </aside>

          <main className="sess-main-list">
            <div className="sess-area-header">
              <span className="sess-current-label">{filter}</span>
              <span className="sess-count">{filteredData.length} Results</span>
            </div>

            {loading ? (
              <div className="sess-loader">Fetching your cosmic history...</div>
            ) : filteredData.length === 0 ? (
              <div className="sess-empty">
                <FaExclamationCircle className="sess-empty-icon" />
                {/* <p>No {filter.toLowerCase()} history found.</p>
                 */}
                 <p style={{ color: "black" }}>
  No {filter.toLowerCase()} history found.
</p>
              </div>
            ) : (
              <>
                <div className="sess-compact-grid">
                  {paginatedData.map((astro, index) => (
                    <div key={index} className="sess-compact-card">
                      <div className="sess-card-top">
                        <div className="sess-astro-profile">
                          <div className="sess-img-box">
                            <img src={astro.photoUrlpath} alt={astro.astrologerName} />
                            <span className="sess-type-icon"><FaCommentDots /></span>
                          </div>
                          <div className="sess-name-meta">
                            <p>{astro.astrologerName}</p>
                          </div>
                        </div>
                        <div className="sess-status-meta">
                          <span className="sess-pill-green">{astro.status}</span>
                          <p className="sess-req-txt">Sessions: {astro.sessions?.length || 0}</p>
                        </div>
                      </div>
                      <div className="sess-card-bottom">
                        <div className="sess-meta-data">
                          <div>
                            <label>DATE &amp; TIME</label>
                            <p>{astro.chatDateTime}</p>
                          </div>
                          <div>
                            <label>DURATION</label>
                            <p>{astro.sessions?.[0]?.duration || "0s"}</p>
                          </div>
                        </div>
                        <button className="sess-view-link" onClick={() => openDetail(astro)}>
                          VIEW DETAILS →
                        </button>
                      </div>
                    </div>
                  ))}
                </div>

                {totalPages > 1 && (
                  <div className="sess-list-pagination">
                    <button
                      className="sess-pag-btn"
                      disabled={listPage === 1}
                      onClick={() => setListPage((p) => p - 1)}
                    >
                      <FaChevronLeft /> Prev
                    </button>
                    <div className="sess-page-numbers">
                      {Array.from({ length: totalPages }, (_, i) => i + 1).map((n) => (
                        <button
                          key={n}
                          className={`sess-page-num ${listPage === n ? "active" : ""}`}
                          onClick={() => setListPage(n)}
                        >
                          {n}
                        </button>
                      ))}
                    </div>
                    <button
                      className="sess-pag-btn"
                      disabled={listPage === totalPages}
                      onClick={() => setListPage((p) => p + 1)}
                    >
                      Next <FaChevronRight />
                    </button>
                  </div>
                )}
              </>
            )}
          </main>

          {/* Stats desktop */}
          <div className="sess-stats-panel">
            <div className="sess-black-card">
              <label className="sess-stats-head">QUICK STATS</label>
              <div className="sess-stats-flex">
                <div className="sess-stat-unit">
                  <h3>{sessions.length}</h3>
                  <p>TOTAL CHATS</p>
                </div>
                <div className="sess-stat-unit">
                  <h3>0</h3>
                  <p>VOICE CALLS</p>
                </div>
              </div>
              <div className="sess-support-txt">
                <span className="sess-dot-green"></span> Support Available 24/7
              </div>
            </div>
          </div>

        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MySessionsPage;
